import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.4 }}
  >
    <motion.span
      className="block will-change-transform"
      variants={{
        hidden: { y: "112%" },
        show: { y: "0%", transition: { duration: 0.95, delay, ease: EASE } },
      }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const ImageReveal = ({ src, alt = "", className = "", imgClassName = "", children }) => (
  <motion.div
    className={`overflow-hidden ${className}`}
    initial={{ clipPath: "inset(10% 6% 10% 6%)", opacity: 0 }}
    whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 1.1, ease: EASE }}
  >
    <motion.img
      src={src}
      alt={alt}
      loading="lazy"
      className={`h-full w-full object-cover ${imgClassName}`}
      initial={{ scale: 1.18 }}
      whileInView={{ scale: 1 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1.5, ease: EASE }}
    />
    {children}
  </motion.div>
);
